import { StationContext } from "contexts";
import { Path, StationStatus } from "enums";
import PayWithPesoModule from "modules/payment/pay-with-peso/pay-with-peso.module";
import PayWithLOCQPayModule from "modules/payment/pay-with-locqpay/pay-with-locqpay.module";
import PaymentHistoryForBusiness from "modules/payment/payment-history-business/payment-history-business.module";
import PaymentHistoryForConsumer from "modules/payment/payment-history-consumer/payment-history-consumer.module";
import NonFuelModule from "modules/payment/non-fuel/non-fuel.module";
import React, { useContext } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import NonFuelBusinessModule from "modules/payment/non-fuel-business/non-fuel-business.module";

const PaymentHistoryPage = () => {
  const { station } = useContext(StationContext);
  const { isPlbOnboarded, isPlcOnboarded, status } = station;
  return (
    <Switch>
      {isPlbOnboarded && (
        <Route exact path={Path.PaymentHistoryBusiness} component={PaymentHistoryForBusiness} />
      )}

      {status === StationStatus.Active && (
        <Route exact path={Path.PayWithLOCQPay} component={PayWithLOCQPayModule} />
      )}

      {status === StationStatus.Active && (
        <Route exact path={Path.PaymentHistoryConsumer} component={PaymentHistoryForConsumer} />
      )}
      {status === StationStatus.Active && (
        <Route exact path={Path.PayWithPeso} component={PayWithPesoModule} />
      )}

      {status === StationStatus.Active && (
        <Route exact path={Path.NonFuel} component={NonFuelModule} />
      )}

      {status === StationStatus.Active && (
        <Route exact path={Path.LOCQPayNonFuel} component={NonFuelBusinessModule} />
      )}
      <Redirect
        to={
          isPlbOnboarded
            ? Path.PaymentHistoryBusiness
            : isPlcOnboarded
            ? Path.PaymentHistoryConsumer
            : Path.VIPAccount
        }
      />
    </Switch>
  );
};

export default PaymentHistoryPage;
